// CopyButton - copy-to-clipboard button with a transient "Copied" confirmation.

import { Check, Copy } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import { cn } from '@/lib/classnames';

export function CopyButton({ text, label }: { text: string; label: string }) {
  const [copied, setCopied] = useState(false);
  const timerRef = useRef<number | null>(null);

  // Clear the pending reset on unmount so the timer doesn't setCopied on
  // an unmounted component.
  useEffect(
    () => () => {
      if (timerRef.current != null) window.clearTimeout(timerRef.current);
    },
    [],
  );

  const onClick = async () => {
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      return;
    }
    if (timerRef.current != null) window.clearTimeout(timerRef.current);
    setCopied(true);
    timerRef.current = window.setTimeout(() => {
      setCopied(false);
      timerRef.current = null;
    }, 1500);
  };

  const Icon = copied ? Check : Copy;
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn('btn-secondary btn-sm', copied && 'text-verdict-clean')}
    >
      <Icon className="w-3.5 h-3.5" />
      {copied ? 'Copied' : label}
    </button>
  );
}
